import { makeStyles } from '@material-ui/core'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((themes) => ({
  root: {
    '& .MuiDialog-paper': {
      width: '520px',
      maxHeight: 'calc(100vh - 180px)',
      overflowX: 'auto',
      padding: '3rem',
    },
  },
  inputBox: {
    columnGap: '3.2rem',
    rowGap: '1rem',
  },
  input: {
    '&.MuiOutlinedInput-root': {
      width: '100%',
      height: '48px !important',
    },

    '& .MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },

  actionBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column-reverse',
    gap: '0.5rem',
  },
  actionBoxInDialog: {
    flexDirection: 'row',
    [useBreakpoints(themes).lessThan.sm]: {
      flexDirection: 'column-reverse',
    },
  },
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  checkbox: {
    '&.MuiCheckbox-root': {
      color: `${themes.colors['primary']} !important`,
    },
  },
  textWarning: {
    color: themes.colors['primary-300'],
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '24px',
    marginBottom: 32,
    marginTop: 42,
  },
}))
